import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/_Login.vue'
import Menu from '../views/_WithTheMenu.vue'
import Accueil from '../views/PageAccueil.vue'
import Empty from '../views/_Empty.vue'
import Params from '../views/PageParams.vue'
import Test from '../views/Test.vue'
import Backoffice from '../views/PageBackoffice.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Login',
    components: {
      menu: Empty,
      main: Login
    }
  },{
    path: '/accueil',
    name: 'Accueil',
    components: {
      menu: Menu,
      main: Accueil
    },
    meta: {
      requiresAuth: true,
    },
  },{
    path: '/projets',
    name: 'Projets',
    components: {
      menu: Menu,
      main: () => import( '../views/PageProjets.vue')
    },
    meta: {
      requiresAuth: true,
    },
    children:[
      {
        path: '',
        component: () => import('../views/Projets/List.vue'),
        meta: {
          requiresAuth: true,
          requiresPerm: 'projetBasic',
        }
      }
    ]
  },
  
  {
    path: '/projet/:_id',
    name: 'projet',
    components: {
      menu: Menu,
      main: () => import( '../views/PageProjet.vue')
    },
    meta: {
      requiresAuth: true,
      requiresPerm: 'projetBasic',
    },
    children:[
      {
        path: 'contrat',
        name: 'Contrat',
        component: () => import( '../views/Projet/Contrat.vue'),
        meta:{
          requiresAuth: true,
          requiresPerm: 'projetContrats',
        },
      },{
        path: 'facture',
        name: 'Factures',
        component: () => import( '../views/Projet/Factures.vue'),
        meta:{
          requiresAuth: true,
          requiresPerm: 'projetFactures',
        },
      },{
        path: 'frais',
        name: 'Frais',
        component: () => import( '../views/Projet/NotesDeFrais.vue'),
        meta:{
          requiresAuth: true,
          requiresPerm: 'projetNdfs',
        },
      },{
        path: 'prestations',
        name: 'Prestations',
        component: () => import( '../views/Projet/NotesDePrestations.vue'),
        meta:{
          requiresAuth: true,
          requiresPerm: 'projetPrestas',
        },
      },{
        path: 'analyse',
        name: 'Analyse',
        component: () => import( '../views/Projet/Analyse.vue'),
        meta:{
          requiresAuth: true,
          requiresPerm: 'projetAnalyses',
        },
      }
    ],
  },{
    path: '/saisie/',
    name: 'saisie',
    components: {
      menu: Menu,
      main: () => import( '../views/PageTemps.vue')
    },
    meta: {
      requiresAuth: true,
      requiresPerm: "temps",
    }
  },{
    path: '/equipe/',
    name: 'Equipe',
    components: {
      menu: Menu,
      main: () => import( '../views/PageUsers.vue')
    },
    meta: {
      requiresAuth: true,
    },
    children:[
      {
        path: 'utilisateurs',
        component: () => import('../views/Users/UserCardsList.vue'),
        meta: {
          requiresAuth: true,
          requiresPerm: "userAdvanced",
        },
      },{
        path: 'utilisateurs/:_id',
        component: () => import('../views/Users/UserPage.vue'),
        meta: {
          requiresAuth: true,
          requiresPerm: "userAdvanced",
        },
      }
    ] 
  },{
    path: '/params',
    name: 'Params',
    components: {
      menu: Menu,
      main: Params
    },
    meta: {
      requiresAuth: true,
      requiresPerm: "params",
    },
    children:[
      {
        path: 'listes',
        name: 'Listes',
        component:() => import('../views/Params/Listes.vue'),
        meta: {
          requiresAuth: true,
          requiresPerm: "params",
        },
      },{
        path: 'temps',
        name: 'Temps',
        component:() => import('../views/Params/Temps.vue'),
        meta: {
          requiresAuth: true,
          requiresPerm: "params",
        },
      },{
        path: 'agence',
        name: 'Agence',
        component:() => import('../views/Params/Agence.vue'),
        meta: {
          requiresAuth: true,
          requiresPerm: "params",
        },
      }
    ]
  },{
    path: '/contacts',
    name: 'Contacts',
    components: {
      menu: Menu,
      main:  () => import( '../views/PageContacts.vue')
    },
    meta: {
      requiresAuth: true,
      requiresPerm: "contacts",
    },
  },{
    path: '/agence',
    name: 'Agence',
    components: {
      menu: Menu,
      main:  () => import( '../views/PageAgence.vue')
    },
    meta: {
      requiresAuth: true,
      requiresPerm: "params",
    },
  },{
    path: '/test',
    name: 'Test',
    components: {
      menu: Menu,
      main: Test
    },
    meta: {
      requiresAuth: true,
      requiresPerm: "res",
    },
  },{
    path: '/backoffice',
    name: 'Backoffice',
    components: {
      menu: Menu,
      main: Backoffice
    },
    meta: {
      requiresAuth: true,
      requiresPerm: "res",
    },
    children:[
      {
        path: 'addagence',
        name: 'addagence',
        component: () => import('../views/Backoffice/addAgence.vue'),
        meta: {
          requiresAuth: true,
          requiresPerm: "res",
        },
      },{
        path: 'importer',
        name: 'importer',
        component: () => import('../views/Backoffice/importer.vue'),
        meta: {
          requiresAuth: true,
          requiresPerm: "res",
        },
      },{
        path: 'application',
        name: 'application',
        component: () => import('../views/Backoffice/application.vue'),
        meta: {
          requiresAuth: true,
          requiresPerm: "res",
        },
      },
    ]
  }
]

export default routes